import React from "react";
import Layout from "src/components/Layout";
import "./HealthSurveillance.css";
import image from "../../images/5.png";
import InfoCard from "src/components/InfoCard";

const healthsurveillance: React.FC = () => {
  return (
    <Layout>
      <InfoCard title={"Health Surveillance"} image={image}>
        <div className="health-details">
          <p>
            It is a legal obligation for employers if the employees are exposed
            to certain hazards within the workplace.
          </p>
          <p>
            <strong></strong>
            Routine health checks are arranged periodically to detect early
            signs of work-related health issues.
          </p>
          <p>
            <strong>
              Services provided (Duration of the appointment of each test of the
              following is 15 min) : <br></br>
            </strong>
            <br></br>• Spirometry with report. <br></br>• Audiometry with
            report.<br></br>• ECG with report.<br></br>• Stress ECG (Bruce
            Protocol Treadmill test).<br></br>• Vision Test (Acuity, Color) with
            report.<br></br>• Drug & Alcohol & Urine analyses test with
            certificate.<br></br>• Chester Step Test & VO2 MAX with a report.
            <br></br>• Full physical Assessment with report.<br></br>• All
            required laboratory tests. <br></br>• Radiology tests (Plain X-Ray -
            Ultrasonography).<br></br>  {" "}
          </p>
        </div>
      </InfoCard>
    </Layout>
  );
};

export default healthsurveillance;
